import { SharedState } from "interfaces/filterContext";


/**
 * Retrieves a value from the shared state by key.
 * @param sharedState - The current shared state object.
 * @param key - The key to retrieve from the shared state.
 * @returns The value associated with the key in the shared state.
 */
export const getSharedState = (sharedState: SharedState, key: string): any => {
    return sharedState[key];
};

/**
 * Updates a specific key in the shared state.
 * @param sharedState - The current shared state object.
 * @param setSharedState - The function to update the shared state.
 * @param key - The key to update in the shared state.
 * @param value - The new value to set for the key.
 */
export const setSharedStateValue = (
    sharedState: SharedState,
    setSharedState: React.Dispatch<React.SetStateAction<SharedState>>,
    key: string,
    value: any
): void => {
    setSharedState((prevState) => {
        // Use JSON.stringify for a deep comparison of object values.
        if (JSON.stringify(prevState[key]) === JSON.stringify(value)) {
            return prevState;
        }
        return {
            ...prevState,
            [key]: value,
        };
    });
};